import { z } from 'zod';
import { ALERT_CATEGORY_KEYS, DEFAULT_ALERT_CATEGORY } from '@/routes/_staff/equipment/-shared/alerts/-constants';
const implementedCategorySchema = z.enum(ALERT_CATEGORY_KEYS);

/** URL category クエリの正規化（未指定・将来カテゴリ・不正値 → DEFAULT_ALERT_CATEGORY） */
export const equipmentAlertCategorySearchSchema = z.string().optional().transform(value => {
  if (value == null || value === '') {
    return DEFAULT_ALERT_CATEGORY;
  }
  const parsed = implementedCategorySchema.safeParse(value);
  if (parsed.success) {
    return parsed.data;
  }
  return DEFAULT_ALERT_CATEGORY;
});